import classNames from 'classnames';
import { ServiceType } from '../../codegen/vehicles';
import { SERVICE_TO_TRANSLATION_KEY } from '../../i18n/enumMappings';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { CustomFormattedMessage } from '../../i18n/i18n';

type ServiceIconProps = {
  service: ServiceType;
  className?: string;
};

const serviceTypesToIcon: { [key in ServiceType]: string } = {
  FUELING: 'rioglyph rioglyph-filling-station',
  BREAKDOWN: 'rioglyph rioglyph-workshop',
  PARKING: 'rioglyph rioglyph-parking',
  WASHING: 'rioglyph rioglyph-sparkles',
  CHARGING: 'rioglyph rioglyph-plugged-on',
  OTHER: 'rioglyph rioglyph-shopping-cart',
};

export const ServiceIcon = ({ service, className }: ServiceIconProps) => (
  <OverlayTrigger
    overlay={
      <Tooltip allowOnTouch>
        <span>
          <CustomFormattedMessage id={SERVICE_TO_TRANSLATION_KEY[service]} />
        </span>
      </Tooltip>
    }
  >
    <span className={classNames(serviceTypesToIcon[service], className)} />
  </OverlayTrigger>
);
